// Rich text pasted into the editor often joins every word with &nbsp;. Those are
// non-breaking, so a paragraph has no legal break point and runs past its container
// instead of wrapping. Normalize them to plain spaces so text wraps at word
// boundaries; pair with overflowWrap: 'break-word' to catch long unbroken tokens.
export function wrappableHtml(html) {
  return (html || '').replace(/&nbsp;|\u00A0/gi, ' ');
}
